module.exports = __webpack_public_path__ + "static/img/oops.77356f79.svg";